import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  visitType: 'Home',
  labAddress: null,
  homeAddress: null,
  labDetails: null
};
export const AddressSlice = createSlice({
  name: 'AddressSlice',
  initialState,

  reducers: {
    setVisitType: (state, action) => {
      state.visitType = action.payload;
    },
    setLabAddress: (state, action) => {
      state.labAddress = action.payload;
    },
    setHomeAddress: (state, action) => {
      state.homeAddress = action.payload;
    },
    setRemoveAddressData: (state, action) => {
      state.homeAddress = null;
      state.labAddress = null;
      state.labAddress = null;
    },
    setLabDetails: (state, action) => {
      state.labDetails = action.payload;
    }
  }
});
export const {
  setVisitType,
  setLabAddress,
  setHomeAddress,
  setRemoveAddressData,
  setLabDetails
} = AddressSlice.actions;
export default AddressSlice.reducer;
